import React from 'react';

const CarouselRightArrow = () => {
  const inlineStyles = {
    root: {
      cursor: 'pointer',
      transition: 'all 0.2s ease',
    },
    background: {
      fill: '#FBF9F7',
      transition: 'fill 0.2s ease',
    },
    arrow: {
      fill: '#162C55',
      transition: 'fill 0.2s ease',
    },
  };

  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={inlineStyles.root}
      onMouseEnter={e => {
        const rect = e.currentTarget.querySelector('rect');
        const path = e.currentTarget.querySelector('path');
        if (rect) rect.style.fill = '#162C55';
        if (path) path.style.fill = 'white';
      }}
      onMouseLeave={e => {
        const rect = e.currentTarget.querySelector('rect');
        const path = e.currentTarget.querySelector('path');
        if (rect) rect.style.fill = '#FBF9F7';
        if (path) path.style.fill = '#162C55';
      }}
    >
      <rect
        width="56"
        height="56"
        rx="28"
        transform="matrix(-1 0 0 1 56 0)"
        style={inlineStyles.background}
      />
      <path
        d="M34.9725 27.5224L28.4725 21.0224C28.2125 20.7624 27.7825 20.7624 27.5125 21.0224C27.2525 21.2824 27.2525 21.7124 27.5125 21.9824L32.8625 27.3324H21.4925C21.1225 27.3324 20.8225 27.6324 20.8225 28.0024C20.8225 28.3724 21.1225 28.6724 21.4925 28.6724H32.8625L27.5225 34.0124C27.2625 34.2724 27.2625 34.7024 27.5225 34.9724C27.6525 35.1024 27.8225 35.1724 28.0025 35.1724C28.1825 35.1724 28.3525 35.1024 28.4825 34.9724L34.9825 28.4724C35.2425 28.2124 35.2425 27.7824 34.9825 27.5124L34.9725 27.5224Z"
        style={inlineStyles.arrow}
      />
    </svg>
  );
};

export default CarouselRightArrow;
